import { PlusIcon } from '@phosphor-icons/react';
import { useKeyboardShortcut } from '@/utils/keyboard';
import { Button } from '@/components/ui/Button';
import { KeyHint } from '@/components/KeyHint';

interface ActionButtonProps {
    title: string;
    onClick: () => void;
    shortcut?: string[];
}

export function ActionButton({ title, onClick, shortcut }: ActionButtonProps) {
    useKeyboardShortcut(shortcut, onClick);

    const isSingleKey = shortcut?.length === 1;

    const trailingIcon =
        shortcut && shortcut.length > 0 ? (
            isSingleKey ? (
                <KeyHint>{shortcut[0]}</KeyHint>
            ) : (
                <span className="flex items-center gap-1">
                    {shortcut.map((key, index) => (
                        <span key={key} className="flex items-center gap-1">
                            {index > 0 && (
                                <span className="text-grey-400 text-xs">+</span>
                            )}
                            <KeyHint>{key}</KeyHint>
                        </span>
                    ))}
                </span>
            )
        ) : undefined;

    return (
        <Button
            variant="pill"
            size="large"
            onClick={onClick}
            leadingIcon={
                <PlusIcon className="size-[18px] shrink-0 text-grey-200" />
            }
            trailingIcon={trailingIcon}
            className="whitespace-nowrap"
        >
            {title}
        </Button>
    );
}
